/* This file was automatically generated - please modify the template not this file! */
import { TextSnippetSelector } from "@teamprevent/common/components/TextSnippetSelector";

import componentRoutes from "./components/componentRoutes";
import Base from "./components/Base";
import { TextSnippet, TextSnippetState, TextSnippetListModel } from "./model";
import { textSnippets as reducer } from "./reducer";
import { routes } from "./routes";
import { loadTextSnippets, loadTextSnippetsSuccess } from "./actions";
import * as selectors from "./selectors";
import { CoreDetails } from "./components/details/CoreDetails";
import { textSnippetApi } from "./textSnippetApi";

export {
    TextSnippet,
    TextSnippetListModel,
    componentRoutes,
    reducer,
    TextSnippetState,
    routes,
    loadTextSnippets,
    loadTextSnippetsSuccess,
    selectors,
    Base,
    CoreDetails,
    textSnippetApi,
    TextSnippetSelector
};
